import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Style } from '../../@shared/models/style.model';

@Component({
    selector: 'app-search-style-container',
    templateUrl: './search-style-container.component.html',
    styleUrls: ['./search-style-container.component.scss'],
})
export class SearchStyleContainerComponent {
    @Input() radius: 'small' | 'normal' | 'large' = 'small';
    @Input() styles: Array<Style> = [];
    @Input() margin = 0;
    @Input() padding = 0;
    @Input() scrolling = 'horizontal';
    @Output() processLink: EventEmitter<string> = new EventEmitter();

    constructor() {}

    process(link: string) {
        console.log("TEST6",link)
        this.processLink.emit(link);
    }
}
